import { InvitationActions } from "@/components/InvitationDialogStacks/InvitationActions";
import { WorkspaceInvite } from "@/types/workspace-invite";

interface Props {
  invites: WorkspaceInvite[];
}

/** Pending workspace invites shown inline on the no-workspace-access page. */
export const PendingWorkspaceInvites = ({ invites }: Props) => {
  if (invites.length === 0) {
    return null;
  }

  return (
    <div className="w-full rounded-lg border border-emerald-200 bg-emerald-50/40 p-4 text-left">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-emerald-800">
        Pending workspace invitations
      </p>
      <InvitationActions invites={invites} />
    </div>
  );
};
